module.exports = __webpack_public_path__ + "img/money.2f5c612e.svg";